module.exports = __webpack_public_path__ + "static/jegede-6bbc9f7951e3f307a8dcc604146b474f.jpg";